import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';
import {RegionsItemType} from 'hostApplicationStoreType';
import {apiConfig} from 'libs/api/api';
import {CountriesType, StatesItemType} from 'types/locationType';

import {MagentoRejectionType} from 'types/types';

import {transformBackendRegions} from './transformBackendRegions/transformBackendRegions';
export type RegionsBackendResponseType = {id: string; name: string; code: string}[];
type LocationType = {countries: CountriesType[]; states: Record<string, RegionsItemType[]>};

const UNITED_STATES = 'US';

const initialState: LocationType = {
    countries: [],
    states: {},
};

export const setCountries = createAction<CountriesType[]>('LOCATION@SET_COUNTRIES');
export const setStates = createAction<Record<string, RegionsItemType[]>>('LOCATION@SET_STATES');

export const fetchStates = createAsyncThunk<
    {data: StatesItemType[]; country: string},
    string,
    {rejectValue: MagentoRejectionType}
    // TODO - GUSA-57892: check FETCH_STATES action type on host
>('LOCATION@FETCH_STATES', async (country = UNITED_STATES) => {
    const {data} = await apiConfig.instanceGusaBackend({
        baseURL: apiConfig.API_URL,
        method: 'get',
        url: `${ENDPOINTS.GET_REGIONS({country})}`,
    });
    return {
        country,
        data: transformBackendRegions(data),
    };
});

/**
 * Reducer for checkoutSideReview
 * @param {LocationType} state - reducer state
 * @return {LocationType} new reducer state
 */
export const location = createReducer<LocationType>(initialState, builder => {
    builder
        .addCase(setCountries, (state, action) => ({
            ...state,
            countries: action.payload,
        }))
        .addCase(setStates, (state, action) => ({
            ...state,
            states: {
                ...state.states,
                ...action.payload,
            },
        }))
        .addCase(fetchStates.fulfilled, (state, action) => ({
            ...state,
            states: {
                ...state.states,
                [action.payload.country]: action.payload.data,
            },
        }));
});
